import { render, staticRenderFns } from "./AccountSettingNotificationTwo.vue?vue&type=template&id=1494339b&"
import script from "./AccountSettingNotificationTwo.vue?vue&type=script&lang=js&"
export * from "./AccountSettingNotificationTwo.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingNotificationTwo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports